export default (parent_store_id, token) => {

  const xhr = new XMLHttpRequest()
  xhr.open('GET', '/api/v1/parent_store_infos/' + parent_store_id)
  xhr.setRequestHeader( 'X-CSRF-Token', token)
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send()
  xhr.addEventListener('load', function(result) {
    if (result.currentTarget.status == 200) {
      if (result.currentTarget.responseText.length == 0) {
          return
      }
      const json = JSON.parse(result.currentTarget.responseText)
      Array.from(document.getElementsByClassName("parent_store_contract_type")).forEach(element => {
        element.value = json.contract_type
      });

      Array.from(document.getElementsByClassName("parent_store_currency_id")).forEach(element => {
        element.value = json.currency_id
      });

      Array.from(document.getElementsByClassName("parent_store_payment_report_publish_days")).forEach(element => {
        element.value = json.payment_report_publish_days
      });

      Array.from(document.getElementsByClassName("parent_store_payment_days")).forEach(element => {
        element.value = json.payment_days
      });

      Array.from(document.getElementsByClassName("parent_store_before_payment_holiday")).forEach(element => {
        if(element.value == json.before_payment_holiday) element.checked = true
      });

      Array.from(document.getElementsByClassName("parent_store_back_deposit_days")).forEach(element => {
        element.value = json.back_deposit_days
      });

      Array.from(document.getElementsByClassName("parent_store_deposit_ratio")).forEach(element => {
        element.value = json.deposit_ratio
      });

      Array.from(document.getElementsByClassName("parent_store_fixed_cost")).forEach(element => {
        element.value = '0.0'
      });

      Array.from(document.getElementsByClassName("parent_store_sales_cost")).forEach(element => {
        element.value = json.sales_cost
      });

      Array.from(document.getElementsByClassName("parent_store_charge_back_cost")).forEach(element => {
        element.value = json.charge_back_cost
      });

      Array.from(document.getElementsByClassName("parent_store_returns_cost")).forEach(element => {
        element.value = json.returns_cost
      });

      Array.from(document.getElementsByClassName("parent_store_credit_cost")).forEach(element => {
        element.value = json.credit_cost
      });

      Array.from(document.getElementsByClassName("parent_store_want_security_code")).forEach(element => {
        if(element.value == json.want_security_code) element.checked = true
      });

      Array.from(document.getElementsByClassName("parent_store_lower_amount")).forEach(element => {
        element.value = json.lower_amount
      });

      Array.from(document.getElementsByClassName("parent_store_higher_amount")).forEach(element => {
        element.value = json.higher_amount
      });

      Array.from(document.getElementsByClassName("parent_store_payment_source")).forEach(element => {
        element.value = json.payment_source
      });

      Array.from(document.getElementsByClassName("parent_store_billing_type")).forEach(element => {
        element.value = json.billing_type
      });

      Array.from(document.getElementsByClassName("parent_store_payeasy_cost")).forEach(element => {
          element.value = json.payeasy_cost
      });

      Array.from(document.getElementsByClassName("parent_store_payeasy_agency_sales_cost")).forEach(element => {
          element.value = json.payeasy_agency_sales_cost
      });

      setUpBrandCollaboration(json);
    } else {
      alert(result.currentTarget.responseText)
    }
  })

};

// 連携先のフィールド情報反映
const setUpBrandCollaboration = (json) => {
    if(json.parent_store_card_companies == null || json.parent_store_card_companies.length === 0 || json.parent_store_card_companies == null || json.parent_store_card_companies.length === 0) {
        alert('対象の親加盟店「ブランド」「料率」「代理店料率」が未設定です。');
    }
    const cardCompanies = json.parent_store_card_companies;
    const eMoneyCompanies = json.parent_store_e_money_companies;
    const qrCodeCompanies = json.parent_store_qr_code_companies;
    const directDebitCompanies = json.parent_store_direct_debit_companies;
    const parentStoreAccountInformation = json.parent_store_account_information;
    const addNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#tag-box"]');
    const nestedFields = document.getElementsByClassName('parent_store_card_company_nested_fields');
    const addEMoneyNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#e-money-destination-form"]');
    const addQrCodeNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#qr-code-destination-form"]');
    const addDirectDebitNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#direct-debit-destination-form"]');
    const eMoneyNestedFields = document.getElementsByClassName('parent_store_e_money_company_nested_fields');
    const qrCodeNestedFields = document.getElementsByClassName('parent_store_qr_code_company_nested_fields');
    const directDebitNestedFields = document.getElementsByClassName('parent_store_direct_debit_company_nested_fields');

    // 連携先(クレジットカード)処理
    if(nestedFields.length === 0) {
        // When the store doesn't have any connection.

        for(let i = 0; i < cardCompanies.length; i++) {
            addNestedFieldsBtn.click();
        }
        const deleteBtns = document.getElementById('tag-box').querySelectorAll('a');
        for(let i = 0; i < deleteBtns.length; i++) {
            deleteBtns[i].classList.add('d-none');
        }
        const cardCompanyElms = document.getElementsByClassName('parent_store_card_company');
        for(let i = 0; i < cardCompanyElms.length; i++) {
            cardCompanyElms[i].value = cardCompanies[i].card_company_id;
            cardCompanyElms[i].classList.add('parent_store_item');
            cardCompanyElms[i].disabled = true;
        }
        const ratioElms = document.getElementsByClassName('parent_store_ratio');
        for(let i = 0; i < ratioElms.length; i++) {
            ratioElms[i].value = cardCompanies[i].ratio;
            ratioElms[i].classList.add('parent_store_item');
            ratioElms[i].disabled = true;
        }
        const agencyRatioElms = document.getElementsByClassName('parent_store_agency_sales_ratio');
        for(let i = 0; i < agencyRatioElms.length; i++) {
            agencyRatioElms[i].value = cardCompanies[i].agency_sales_ratio;
            agencyRatioElms[i].classList.add('parent_store_item');
            agencyRatioElms[i].disabled = true;
        }
    } else {
        // When the store has some connection.

        const tmpCardCompanies = cardCompanies;
        loopTop:
        for(let i = 0; i < nestedFields.length; i++) {
            const nestedField = nestedFields[i];
            const nestedFieldsHiddenElm = nestedField.querySelector('input[type="hidden"]');
            const cardCompanyElm = nestedField.querySelector('.parent_store_card_company');
            const ratioElm = nestedField.querySelector('.parent_store_ratio');
            const agencyRatioElm = nestedField.querySelector('.parent_store_agency_sales_ratio');
            for(let j = 0; j < cardCompanies.length; j++) {
                if(cardCompanyElm.value === cardCompanies[j].card_company_id.toString()) {
                    nestedField.style.display = null;
                    nestedField.querySelector('a').classList.add('d-none');
                    nestedFieldsHiddenElm.value = false;
                    cardCompanyElm.disabled = true;
                    ratioElm.value = cardCompanies[j].ratio;
                    ratioElm.disabled = true;
                    agencyRatioElm.value = cardCompanies[j].agency_sales_ratio;
                    agencyRatioElm.disabled = true;
                    tmpCardCompanies.splice(j, 1);
                    continue loopTop;
                }
            }
            const nextElm = nestedField.nextElementSibling;
            if(nextElm != null && nextElm.tagName === 'INPUT') {
                nestedField.style.display = 'none';
                nestedFieldsHiddenElm.value = 1;
            } else {
                nestedField.remove();
                i--;
            }
        }
        for(let i = 0; i < tmpCardCompanies.length; i++) {
            addNestedFieldsBtn.click();
            const deleteBtns = document.getElementById('tag-box').querySelectorAll('a');
            deleteBtns[deleteBtns.length-1].classList.add('d-none');
            const cardCompanyElms = document.getElementsByClassName('parent_store_card_company');
            cardCompanyElms[cardCompanyElms.length-1].value = tmpCardCompanies[i].card_company_id;
            cardCompanyElms[cardCompanyElms.length-1].classList.add('parent_store_item');
            cardCompanyElms[cardCompanyElms.length-1].disabled = true;
            const ratioElms = document.getElementsByClassName('parent_store_ratio');
            ratioElms[ratioElms.length-1].value = tmpCardCompanies[i].ratio;
            ratioElms[ratioElms.length-1].classList.add('parent_store_item');
            ratioElms[ratioElms.length-1].disabled = true;
            const agencyRatioElms = document.getElementsByClassName('parent_store_agency_sales_ratio');
            agencyRatioElms[agencyRatioElms.length-1].value = tmpCardCompanies[i].agency_sales_ratio;
            agencyRatioElms[agencyRatioElms.length-1].classList.add('parent_store_item');
            agencyRatioElms[agencyRatioElms.length-1].disabled = true;
        }
    }

    // 連携先(電子マネー)処理
    if(eMoneyNestedFields.length === 0) {
      // When the store doesn't have any connection.

      for(let i = 0; i < eMoneyCompanies.length; i++) {
        addEMoneyNestedFieldsBtn.click();
      }
      const deleteBtns = document.getElementById('e-money-destination-form').querySelectorAll('a');
      for(let i = 0; i < deleteBtns.length; i++) {
          deleteBtns[i].classList.add('d-none');
      }
      const eMoneyCompanyElms = document.getElementsByClassName('parent_store_e_money_company');
      for(let i = 0; i < eMoneyCompanyElms.length; i++) {
        eMoneyCompanyElms[i].value = eMoneyCompanies[i].e_money_company_id;
        eMoneyCompanyElms[i].classList.add('parent_store_item');
        eMoneyCompanyElms[i].disabled = true;
      }
      const ratioElms = document.getElementsByClassName('parent_store_e_money_ratio');
      for(let i = 0; i < ratioElms.length; i++) {
          ratioElms[i].value = eMoneyCompanies[i].ratio;
          ratioElms[i].classList.add('parent_store_item');
          ratioElms[i].disabled = true;
      }
      const agencyRatioElms = document.getElementsByClassName('parent_store_e_money_agency_sales_ratio');
      for(let i = 0; i < agencyRatioElms.length; i++) {
          agencyRatioElms[i].value = eMoneyCompanies[i].agency_sales_ratio;
          agencyRatioElms[i].classList.add('parent_store_item');
          agencyRatioElms[i].disabled = true;
      }
  } else {
      // When the store has some connection.

      const tmpEMoneyCompanies = eMoneyCompanies;
      loopTop:
      for(let i = 0; i < eMoneyNestedFields.length; i++) {
          const nestedField = eMoneyNestedFields[i];
          const nestedFieldsHiddenElm = nestedField.querySelector('input[type="hidden"]');
          const eMoneyCompanyElm = nestedField.querySelector('.parent_store_e_money_company');
          const ratioElm = nestedField.querySelector('.parent_store_e_money_ratio');
          const agencyRatioElm = nestedField.querySelector('.parent_store_e_money_agency_sales_ratio');
          for(let j = 0; j < eMoneyCompanies.length; j++) {
              if(eMoneyCompanyElm.value === eMoneyCompanies[j].e_money_company_id.toString()) {
                  nestedField.style.display = null;
                  nestedField.querySelector('a').classList.add('d-none');
                  nestedFieldsHiddenElm.value = false;
                  eMoneyCompanyElm.disabled = true;
                  ratioElm.value = eMoneyCompanies[j].ratio;
                  ratioElm.disabled = true;
                  agencyRatioElm.value = eMoneyCompanies[j].agency_sales_ratio;
                  agencyRatioElm.disabled = true;
                  tmpEMoneyCompanies.splice(j, 1);
                  continue loopTop;
              }
          }
          const nextElm = nestedField.nextElementSibling;
          if(nextElm != null && nextElm.tagName === 'INPUT') {
              nestedField.style.display = 'none';
              nestedFieldsHiddenElm.value = 1;
          } else {
              nestedField.remove();
              i--;
          }
      }
      for(let i = 0; i < tmpEMoneyCompanies.length; i++) {
        addEMoneyNestedFieldsBtn.click();
          const deleteBtns = document.getElementById('e-money-destination-form').querySelectorAll('a');
          deleteBtns[deleteBtns.length-1].classList.add('d-none');
          const eMoneyCompanyElms = document.getElementsByClassName('parent_store_e_money_company');
          eMoneyCompanyElms[eMoneyCompanyElms.length-1].value = tmpEMoneyCompanies[i].e_money_company_id;
          eMoneyCompanyElms[eMoneyCompanyElms.length-1].classList.add('parent_store_item');
          eMoneyCompanyElms[eMoneyCompanyElms.length-1].disabled = true;
          const ratioElms = document.getElementsByClassName('parent_store_e_money_ratio');
          ratioElms[ratioElms.length-1].value = tmpEMoneyCompanies[i].ratio;
          ratioElms[ratioElms.length-1].classList.add('parent_store_item');
          ratioElms[ratioElms.length-1].disabled = true;
          const agencyRatioElms = document.getElementsByClassName('parent_store_e_money_agency_sales_ratio');
          agencyRatioElms[agencyRatioElms.length-1].value = tmpEMoneyCompanies[i].agency_sales_ratio;
          agencyRatioElms[agencyRatioElms.length-1].classList.add('parent_store_item');
          agencyRatioElms[agencyRatioElms.length-1].disabled = true;
      }
    }

  // 連携先(QRコード)処理
  if (qrCodeNestedFields.length === 0) {
    // When the store doesn't have any connection.

    for(let i = 0; i < qrCodeCompanies.length; i++) {
      addQrCodeNestedFieldsBtn.click();
    }
    const deleteBtns = document.getElementById('qr-code-destination-form').querySelectorAll('a');
    for(let i = 0; i < deleteBtns.length; i++) {
      deleteBtns[i].classList.add('d-none');
    }
    const qrCodeCompanyElms = document.getElementsByClassName('parent_store_qr_code_company');
    for(let i = 0; i < qrCodeCompanyElms.length; i++) {
      qrCodeCompanyElms[i].value = qrCodeCompanies[i].qr_code_company_id;
      qrCodeCompanyElms[i].classList.add('parent_store_item');
      qrCodeCompanyElms[i].disabled = true;
    }
    const ratioElms = document.getElementsByClassName('parent_store_qr_code_ratio');
    for(let i = 0; i < ratioElms.length; i++) {
      ratioElms[i].value = qrCodeCompanies[i].ratio;
      ratioElms[i].classList.add('parent_store_item');
      ratioElms[i].disabled = true;
    }
    const agencyRatioElms = document.getElementsByClassName('parent_store_qr_code_agency_sales_ratio');
    for(let i = 0; i < agencyRatioElms.length; i++) {
      agencyRatioElms[i].value = qrCodeCompanies[i].agency_sales_ratio;
      agencyRatioElms[i].classList.add('parent_store_item');
      agencyRatioElms[i].disabled = true;
    }
  } else {
    // When the store has some connection.

    const tmpQrCodeCompanies = qrCodeCompanies;
    loopTop:
    for(let i = 0; i < qrCodeNestedFields.length; i++) {
      const nestedField = qrCodeNestedFields[i];
      const nestedFieldsHiddenElm = nestedField.querySelector('input[type="hidden"]');
      const qrCodeCompanyElm = nestedField.querySelector('.parent_store_qr_code_company');
      const ratioElm = nestedField.querySelector('.parent_store_qr_code_ratio');
      const agencyRatioElm = nestedField.querySelector('.parent_store_qr_code_agency_sales_ratio');
      for(let j = 0; j < qrCodeCompanies.length; j++) {
        if(qrCodeCompanyElm.value === qrCodeCompanies[j].qr_code_company_id.toString()) {
          nestedField.style.display = null;
          nestedField.querySelector('a').classList.add('d-none');
          nestedFieldsHiddenElm.value = false;
          qrCodeCompanyElm.disabled = true;
          ratioElm.value = qrCodeCompanies[j].ratio;
          ratioElm.disabled = true;
          agencyRatioElm.value = qrCodeCompanies[j].agency_sales_ratio;
          agencyRatioElm.disabled = true;
          tmpQrCodeCompanies.splice(j, 1);
          continue loopTop;
        }
      }
      const nextElm = nestedField.nextElementSibling;
      if(nextElm != null && nextElm.tagName === 'INPUT') {
        nestedField.style.display = 'none';
        nestedFieldsHiddenElm.value = 1;
      } else {
        nestedField.remove();
        i--;
      }
    }
    for(let i = 0; i < tmpQrCodeCompanies.length; i++) {
      addQrCodeNestedFieldsBtn.click();
        const deleteBtns = document.getElementById('qr-code-destination-form').querySelectorAll('a');
        deleteBtns[deleteBtns.length-1].classList.add('d-none');
        const qrCodeCompanyElms = document.getElementsByClassName('parent_store_qr_code_company');
        qrCodeCompanyElms[qrCodeCompanyElms.length-1].value = tmpQrCodeCompanies[i].qr_code_company_id;
        qrCodeCompanyElms[qrCodeCompanyElms.length-1].classList.add('parent_store_item');
        qrCodeCompanyElms[qrCodeCompanyElms.length-1].disabled = true;
        const ratioElms = document.getElementsByClassName('parent_store_qr_code_ratio');
        ratioElms[ratioElms.length-1].value = tmpQrCodeCompanies[i].ratio;
        ratioElms[ratioElms.length-1].classList.add('parent_store_item');
        ratioElms[ratioElms.length-1].disabled = true;
        const agencyRatioElms = document.getElementsByClassName('parent_store_qr_code_agency_sales_ratio');
        agencyRatioElms[agencyRatioElms.length-1].value = tmpQrCodeCompanies[i].agency_sales_ratio;
        agencyRatioElms[agencyRatioElms.length-1].classList.add('parent_store_item');
        agencyRatioElms[agencyRatioElms.length-1].disabled = true;
    }
  }

  // 連携先(口座引落)処理
  if(directDebitNestedFields.length === 0 && addDirectDebitNestedFieldsBtn !== null) {
    // When the store doesn't have any connection.

    for(let i = 0; i < directDebitCompanies.length; i++) {
      addDirectDebitNestedFieldsBtn.click();
    }
    const deleteBtns = document.getElementById('direct-debit-destination-form').querySelectorAll('a');
    for(let i = 0; i < deleteBtns.length; i++) {
        deleteBtns[i].classList.add('d-none');
    }
    const directDebitCompanyElms = document.getElementsByClassName('parent_store_direct_debit_company');
    for(let i = 0; i < directDebitCompanyElms.length; i++) {
      directDebitCompanyElms[i].value = directDebitCompanies[i].direct_debit_company_id;
      directDebitCompanyElms[i].classList.add('parent_store_item');
      directDebitCompanyElms[i].disabled = true;
    }
    const ratioElms = document.getElementsByClassName('parent_store_direct_debit_ratio');
    for(let i = 0; i < ratioElms.length; i++) {
        ratioElms[i].value = directDebitCompanies[i].ratio;
        ratioElms[i].classList.add('parent_store_item');
        ratioElms[i].disabled = true;
    }
    const agencyRatioElms = document.getElementsByClassName('parent_store_direct_debit_agency_sales_ratio');
    for(let i = 0; i < agencyRatioElms.length; i++) {
        agencyRatioElms[i].value = directDebitCompanies[i].agency_sales_ratio;
        agencyRatioElms[i].classList.add('parent_store_item');
        agencyRatioElms[i].disabled = true;
    }
  } else {
    // When the store has some connection.

    const tmpDirectDebitCompanies = directDebitCompanies;
    loopTop:
    for(let i = 0; i < directDebitNestedFields.length; i++) {
        const nestedField = directDebitNestedFields[i];
        const nestedFieldsHiddenElm = nestedField.querySelector('input[type="hidden"]');
        const directDebitCompanyElm = nestedField.querySelector('.parent_store_direct_debit_company');
        const ratioElm = nestedField.querySelector('.parent_store_direct_debit_ratio');
        const agencyRatioElm = nestedField.querySelector('.parent_store_direct_debit_agency_sales_ratio');
        for(let j = 0; j < directDebitCompanies.length; j++) {
            if(directDebitCompanyElm.value === directDebitCompanies[j].direct_debit_company_id.toString()) {
                nestedField.style.display = null;
                nestedField.querySelector('a').classList.add('d-none');
                nestedFieldsHiddenElm.value = false;
                directDebitCompanyElm.disabled = true;
                ratioElm.value = directDebitCompanies[j].ratio;
                ratioElm.disabled = true;
                agencyRatioElm.value = directDebitCompanies[j].agency_sales_ratio;
                agencyRatioElm.disabled = true;
                tmpDirectDebitCompanies.splice(j, 1);
                continue loopTop;
            }
        }
        const nextElm = nestedField.nextElementSibling;
        if(nextElm != null && nextElm.tagName === 'INPUT') {
            nestedField.style.display = 'none';
            nestedFieldsHiddenElm.value = 1;
        } else {
            nestedField.remove();
            i--;
        }
    }
    if(addDirectDebitNestedFieldsBtn !== null) {
      for(let i = 0; i < tmpDirectDebitCompanies.length; i++) {
        addDirectDebitNestedFieldsBtn.click();
        const deleteBtns = document.getElementById('direct-debit-destination-form').querySelectorAll('a');
        deleteBtns[deleteBtns.length-1].classList.add('d-none');
        const directDebitCompanyElms = document.getElementsByClassName('parent_store_direct_debit_company');
        directDebitCompanyElms[directDebitCompanyElms.length-1].value = tmpDirectDebitCompanies[i].direct_debit_company_id;
        directDebitCompanyElms[directDebitCompanyElms.length-1].classList.add('parent_store_item');
        directDebitCompanyElms[directDebitCompanyElms.length-1].disabled = true;
        const ratioElms = document.getElementsByClassName('parent_store_direct_debit_ratio');
        ratioElms[ratioElms.length-1].value = tmpDirectDebitCompanies[i].ratio;
        ratioElms[ratioElms.length-1].classList.add('parent_store_item');
        ratioElms[ratioElms.length-1].disabled = true;
        const agencyRatioElms = document.getElementsByClassName('parent_store_direct_debit_agency_sales_ratio');
        agencyRatioElms[agencyRatioElms.length-1].value = tmpDirectDebitCompanies[i].agency_sales_ratio;
        agencyRatioElms[agencyRatioElms.length-1].classList.add('parent_store_item');
        agencyRatioElms[agencyRatioElms.length-1].disabled = true;
      }
    }
  }

  const isRabbitAccountIssued = document.getElementById('is_parent_store_rabbit_account_issued');
  isRabbitAccountIssued.value = "未発行";
  if(parentStoreAccountInformation !== null && parentStoreAccountInformation["rabbit_account_issued_at"]) {
    isRabbitAccountIssued.value = "発行済み";
  }
}
